import { useAppSelector } from "@/lib/hooks/store";
import { RootState } from "@/lib/store/store";


export const getUser = (state:RootState) => state.user.user

export const getApplication = (state:RootState) => state.user.applications

export const getAuth = (state:RootState) => state.user.auth